import { isMobileOnly } from 'react-device-detect';

import { useUser } from '@youga/youga-client-api';

export enum GATE_INFORMATION {
  PASS = 'PASS',
  STRIPE = 'STRIPE',
  AGENT_ANDROID = 'ANDROID',
  AGENT_IOS = 'IOS',
  MOBILE = 'MOBILE',
  LOADING = 'LOADING',
  LICENSE = 'LICENSE',
  ACCOUNT_INVALID = 'ACCOUNT_INVALID',
}

type UseGateInformation = () => GATE_INFORMATION;

const isBrowser = typeof window !== 'undefined';

const useGateInformation: UseGateInformation = () => {
  const {
    data: user,
    isValidating: isValidatingUser,
    error: userError,
  } = useUser();

  if (!isBrowser) {
    return GATE_INFORMATION.LOADING;
  }

  if (isMobileOnly) {
    return GATE_INFORMATION.MOBILE;
  }

  // If we do not know about the user, just return a loading state so we can display a spinner
  if (user == null && isValidatingUser) {
    return GATE_INFORMATION.LOADING;
  }

  if (userError?.response?.status === 404) {
    return GATE_INFORMATION.ACCOUNT_INVALID;
  }

  return GATE_INFORMATION.PASS;
};

export default useGateInformation;
